<template>
  <div :class="queryParam.customer_id == 0 ? 'content content-group' : 'content'">
    <a-spin :spinning="loading">
      <a-button type="primary" @click="add" style="margin-bottom: 10px">
        <a-icon type="plus"></a-icon>
        添加新话术
      </a-button>
      <div v-if="dataSource.length">
        <div
          v-for="(item, index) in dataSource"
          :key="index"
          class="msg-item"
          @click="sendMaterial(item)"
        >
          <div v-html="handleContent(item)"></div>
          <div class="btn-box">
            <a-icon class="icon" type="form" @click.stop="edit(item)" />
          </div>
        </div>
      </div>
      <div v-else-if="title">
        <a-empty :image="simpleImage" description="未搜索到数据" />
      </div>
      <div v-else>
        <a-empty :image="simpleImage" :description="description" />
      </div>
    </a-spin>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue';
import { ListMixin } from '@/mixins/ListMixin';
export default {
  name: 'MaterialListModal',
  mixins: [ListMixin],
  props: ['title'],
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  data() {
    return {
      loading: true,
      activeKey: ['1'],
      navList: [
        {
          title: '自我介绍',
          id: 1
        },
        {
          title: '公司服务',
          id: 2
        }
      ],
      description:
        '你还没有任何公司话术哦，请管理员到句子互动后台话术库中配置公司话术，或者你可以在我的话术中新建属于你自己的话术',
      dataSource: [],
      url: {
        list: 'scrm/work-state/talk'
      },
      queryParam: {
        title: '',
        type: 2,
        customer_id: ''
      }
    };
  },
  created() {},
  mounted() {
    this.loadData();
  },
  methods: {
    // 话术摘要数据处理
    handleContent(data) {
      if (data.type == 'image') {
        let dom = `<div class="welcome-msg">
                    <div class="link">
                        <div class="link-title">${data.title}</div>
                        <img src="${data.content}" style="height: 77px; max-width: 500px;">
                    </div>
                </div>`;
        return dom;
      } else if (data.type == 'news') {
        let cont = data.content;
        if (typeof data.content != 'object') {
          cont = JSON.parse(data.content);
        }
        let dom = `<div class="welcome-msg">
                    <div class="link">
                        <div class="link-title">${data.title}</div>
                        <div class="link-cont">
                            <div class="link-text">${cont.title}<br>${cont.description}</div>
                            <img src="${cont.picurl}">
                        </div>
                    </div>
                </div>`;
        return dom;
      } else if (data.type == 'miniprogram') {
        let cont = data.content;
        if (typeof data.content != 'object') {
          cont = JSON.parse(data.content);
        }
        let dom = `<div class="welcome-msg">
                        <div class="link">
                            <div class="link-title">${data.title}</div>
                            <div class="link-cont link-cont-mini">
                                <div class="link-text">${cont.title}</div>
                                <img src="${cont.picurl}">
                            </div>
                        </div>
                    </div>`;
        return dom;
      } else if (data.type == 'file') {
        let dom = `<div class="welcome-msg">
                    <div class="link">
                        <div class="link-title">${data.title}</div>
                        <div class="link-cont">
                            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABCJJREFUeAHtnUtPMjEUhot8GrwkEhHwfgkLfwH+/61uXbEgYYHXeL8uiGDO+JkQhBnKmbavM28TIsO0p6fv09POGRwtnJycDAwLjAJzMJ7QkUgBAgGbCARCIGAKgLnDCCEQMAXA3GGEEAiYAmDuMEIIBEwBMHcYIQQCpgCYO4wQAgFTAMwdRgiBgCkA5g4jBAzIP9/+1Ot1U6lUzNLSkpmbS38+9Ho98/b2Zm5ubszj46Pv4an78wrk6OjIrK6uqp2OMzA/P2/K5XL06na75uLiIq463Ln0p+iEIW5sbDiHMdr1zs6O2d7eHv0Y+tgbkLW1tSBCCJCtra0gfc/SqbclS/aM4XJ6ejp8qHpfKBRMs9mcaEMiRcpfWL68RYiLDXwigTEnBMrm5uaYM1gfeQPie9jn5+e/utzd3YWHkmkgk6DIBQZqySwQEVyAjIOyt7dnUKFkGkgSFElS0UrmgcRB2d/fN2hQcgEkCUqtVoMJlNwAiYNycHBgUKDkCkgcFFm+EKDkDsgkKJLtC5RqtRp0+colkDgosnyFhJJbIElQ1tfXg0RKroHEQTk8PDQhoHi72+t7uh0fH6u6lD1FoAwGA3N3d6eyZdM4ExEion1+ftqMe6q6P1BKpdJU9dOolAkgIsTz83MaevyyIV8byF1iXyUzS1a73Y5ura+srBj5Xl1mt7xmLcNRsby8PKsZ63aZAdLv98fe2bVW5H+D4T1oYWFhVjPW7TKzZFmPHLQBgYCBIRACAVMAzB1GCBgQmKssuVyVzFguNzWXq5IgSmbd6XTApJ7OHZgIaTQaZnFxUQVDhlwsFqPvNULch5pO8vhaMEDi3czPWRggkml/fHxEN/M08suSJY8i3N7easwEawuzh7y+vpqzs7NgQqB0DBMhKIKE9oNAQhMY6Z9ARgQJfUggoQmM9E8gI4KEPoS5ykorU7cVFC2zh4mQtDJ1WyBomT0MEFshs1ofBkhambotKLTMHmYPYab+PZVgIsR2Zme1PoGAkSUQAgFTAMwdRggYEJirLFeZOlomnsQfJkJcZepomfifAZLkaF7Ow0SIq0wdLRNPmlgwewgz9W9UMBGSNHPycp5AwEgTCIGAKQDmDiOEQMAUAHPHW4TIQ5l/tfj03Vse8v7+buR+1U8Zfsr15zPUn/JL4L6Ktwi5v7/3NabU+/HpuzcgV1dX5unpKXWxXBt8eXkx4ruv4m3JkgG1Wq3oj066/HcVaQgne4YsUw8PD+by8lL9zIqNT16BiGPX19fRy8bJPNX1tmTlSVTNWAlEo56DtgTiQFSNSQLRqOegLYE4EFVjkkA06jloSyAORNWYJBCNeg7aEogDUTUmCUSjnoO2BOJAVI1JAtGo56AtgTgQVWOSQDTqOWhLIA5E1ZgkEI16DtoSiANRNSa/ANf8FAi67r2TAAAAAElFTkSuQmCC">
                            <div class="link-text">${data.source_name}</div>
                        </div>
                    </div>
                </div>`;
        return dom;
      } else if (data.type == 'video') {
        let dom = `<div class="welcome-msg">
                    <div class="link">
                        <div class="link-title">${data.title}</div>
                        <div class="link-cont">
                            <div class="link-text">${data.source_name}</div>
                            <img src="data:image/png;base64,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">
                        </div>
                    </div>
                </div>`;
        return dom;
      } else {
        let dom = `<div class="welcome-msg">
                <div class="link">
                    <div class="link-title">${data.title}</div>
                    <div class="link-cont">
                        <div class="link-text">${data.content}</div>
                    </div>
                </div>
            </div>`;
        return dom;
      }
    },

    // 新增话术
    add() {
      let obj = {
        type: 'add'
      };
      this.$emit('ok', obj);
    },

    // 编辑
    edit(record) {
      let obj = {
        type: 'edit',
        data: record
      };
      this.$emit('ok', obj);
    },

    // 重新加载
    reload() {
      this.loadData();
    }
  },
  watch: {
    title() {
      this.queryParam.title = this.title;
      this.loadData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import '@/style/less/func';
.default-color {
  color: #13c2c2;
}

.content {
  overflow: hidden;
  overflow-y: auto;
  height: calc(100vh - 480px);

  &-group {
    height: calc(100vh - 280px);
  }
}
</style>
